var _excluded = ["name"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import PropTypes from 'prop-types';
import EmailIcon from '@domain-group/fe-co-icon/lib/js/email';
import HouseIcon from '@domain-group/fe-co-icon/lib/js/house';
import HospitalIcon from '@domain-group/fe-co-icon/lib/js/hospital';
import SchoolIcon from '@domain-group/fe-co-icon/lib/js/school';
import SupermarketIcon from '@domain-group/fe-co-icon/lib/js/supermarket';
import MapPinIcon from '@domain-group/fe-co-icon/lib/js/pin';
import { jsx as ___EmotionJSX } from "@emotion/core";
var DEFAULT_ICON = HouseIcon;
var iconMap = {
  house: HouseIcon,
  email: EmailIcon,
  hospital: HospitalIcon,
  supermarket: SupermarketIcon,
  school: SchoolIcon,
  pin: MapPinIcon
};
var Icon = _ref => {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded);
  var SelectedIcon = iconMap[name] || DEFAULT_ICON;
  return ___EmotionJSX(SelectedIcon, props);
};
Icon.propTypes = {
  name: PropTypes.string.isRequired
};
export default Icon;